import React from 'react';
import { Grid, TextField, MenuItem, Autocomplete, Typography, Divider, Box } from '@mui/material';
import { positionOptions, nilPerOralOptions, ivFluidsOptions, oralLiquidsOptions, dietOptions } from '../constants/options';

const VitalInstructionsSection = ({ formData, setFormData, handleInputChange }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>
        Vital & Basic Instructions
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={positionOptions}
            value={formData.position_of_patient || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, position_of_patient: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Position of Patient" name="position_of_patient" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={nilPerOralOptions}
            value={formData.nil_per_oral || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, nil_per_oral: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Nil Per Oral (NPO)" name="nil_per_oral" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={ivFluidsOptions}
            value={formData.iv_fluids_advised || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, iv_fluids_advised: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="IV Fluids Advised" name="iv_fluids_advised" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Oxygen (O2)"
            name="o2"
            value={formData.o2 || ''}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={oralLiquidsOptions}
            value={formData.oral_liquids || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, oral_liquids: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Oral Liquids" name="oral_liquids" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={dietOptions}
            value={formData.diet || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, diet: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Diet Advised" name="diet" />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Motor/Sensory Regression (Observation)"
            name="motor_sensory_regression"
            type="datetime-local"
            value={formData.motor_sensory_regression || ''}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VitalInstructionsSection;
